const gate = (() => {
    const MAX = 16;                 // tune after measuring (8–12 is a good start)
    let inFlight = 0;
    const queue = [];

    // move the function OUTSIDE the while-loop to satisfy no-loop-func
    const run = ( item, API ) => {
        inFlight++;
        item
            .fn( API )
            .then( item.resolve, item.reject )
            .finally(() => { inFlight--; pump( API ); });
    }

    const pump = API => {
        // drain as many as allowed
        while ( inFlight < MAX && queue.length ) {
            const item = queue.shift();
            run( item, API );
        }
    }

    return function gate( API, fn ) {
        return new Promise((resolve, reject) => {
            queue.push( { fn, resolve, reject } );
            pump( API );
        });
    };
})();

// Usage: graphqlGated(API, (API) => API.graphql({ query, variables }))
export function graphqlGated( API, argsOrFn ) {
    // allow both forms for convenience
    const fn =
        typeof argsOrFn === 'function'
            ? argsOrFn
            : () => API.graphql( argsOrFn );

    return gate( API, fn );
}
